import { gql } from "@apollo/client";

const setSouthboundCustomsShipmentControlNumberMutation = gql`
  mutation (
    $customsShipmentId: ID!
    $controlNumber: String!
    $processedBy: String!
  ) {
    setSouthboundCustomsShipmentControlNumber(
      customsShipmentId: $customsShipmentId
      controlNumber: $controlNumber
      processedBy: $processedBy
    ) {
      errors {
        customsShipmentId
        controlNumber
        processedBy
      }
      updatedCustomsShipment {
        id
        canonicalId
        createdAt
        shippedOn
        archivedOn
        controlNumber
        canViewerMarkAsShipped
        canViewerMarkAsArchived
        canViewerSetControlNumber
        processedBy
      }
      succeeded
    }
  }
`;

export default setSouthboundCustomsShipmentControlNumberMutation;
